import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://italia.impultienda.ar';
export const PRODUCT_NAME = 'Mega Pack Qi Gong™';
export const PRICE_EUR = '€19';
export const PRICE_EUR_VALUE = 19;
export const SUPPORT_EMAIL = 'supportelumencreativedigital@gmail.com';
export const INSTAGRAM_URL = 'https://instagram.com/Lumen_Akasha';
export const Section = ({
  children,
  className = '',
  id = '',
  glow = false
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 24
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`relative pt-2 pb-14 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className}`} data-id="element-232" data-mp="kfum9k3xf7yb">
    {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-233" data-mp="20tbcg1n9zfim">
        <div className="absolute -top-16 left-[18%] w-[420px] h-[420px] max-w-[70vw] rounded-full bg-brand-goldLight/40 blur-[120px] animate-aurora-1" data-id="element-234" data-mp="39kj0tmcreupo" />
        <div className="absolute -bottom-20 right-[16%] w-[380px] h-[380px] max-w-[70vw] rounded-full bg-brand-gold/25 blur-[120px] animate-aurora-2" data-id="element-235" data-mp="34itqk8xd2l2n" />
        <div className="absolute top-1/2 left-1/2 w-[560px] h-[320px] max-w-[85vw] rounded-full bg-brand-greenSage/25 blur-[130px] animate-aurora-halo" data-id="element-236" data-mp="2vl19p0bzr5d5" />
        <div className="absolute top-0 left-1/2 w-[70%] h-full bg-gradient-to-t from-transparent via-brand-goldLight/25 to-transparent blur-2xl animate-beam" data-id="element-237" data-mp="2qmzskky4lg4b" />
      </div>}
    {children}
  </motion.section>;
export const SectionHeading = ({
  eyebrow,
  children,
  className = ''
}: {
  eyebrow?: string;
  children: React.ReactNode;
  className?: string;
}) => <div className={`text-center ${className}`} data-id="element-238" data-mp="27tm6l5ce4k0u">
    {eyebrow && <p className="font-seal text-xs md:text-sm uppercase tracking-seal text-brand-goldDark mb-3" data-id="element-239" data-mp="22vud46w3kpuj">
        {eyebrow}
      </p>}
    <h2 className="text-3xl md:text-[2.75rem] md:leading-[1.12] font-display font-bold text-brand-burgundy leading-tight max-w-4xl mx-auto" data-id="element-240" data-mp="1t7ozy6kcpqh1">
      {children}
    </h2>
    <div className="gold-rule mt-5" aria-hidden="true" data-id="element-241" data-mp="1j9sjr0ck45c2">
      <span className="text-brand-gold text-[10px]" data-id="element-242" data-mp="1jbc00qy7qgdu">◆</span>
    </div>
  </div>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple',
  style
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
  style?: React.CSSProperties;
}) => {
  const bgClass = variant === 'purple' ? 'purple-gradient-bg text-brand-surface' : 'gold-gradient-bg text-brand-purpleDark';
  const shadowClass = variant === 'purple' ? 'shadow-[0_14px_30px_-16px_rgba(126,44,33,0.85)] hover:shadow-[0_18px_38px_-16px_rgba(126,44,33,0.95)]' : 'shadow-[0_14px_30px_-16px_rgba(138,107,39,0.7)] hover:shadow-[0_18px_38px_-16px_rgba(138,107,39,0.85)]';
  const classes = `inline-flex items-center justify-center text-center mx-auto px-8 py-4 text-base font-semibold tracking-wide uppercase ${bgClass} rounded-sm ${shadowClass} transition-shadow duration-300 cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.a href={href ?? CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    value: PRICE_EUR_VALUE,
    currency: 'EUR'
  })} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className={classes} style={style} data-id="element-243" data-mp="xy21mvok491m">
      {children}
    </motion.a>;
};